import { ApplicationDataGridRowProps } from '@/models/Application';

// Newest cycle first, then by application type, matching how the applicant dashboard lists applications.
export const sortPartnerApps = (
  apps: ApplicationDataGridRowProps[]
): ApplicationDataGridRowProps[] => {
  return [...apps].sort((a, b) => {
    const cycleSort =
      Number(b.applicationCycle.split('/')[0]) - Number(a.applicationCycle.split('/')[0]);
    if (cycleSort !== 0) {
      return cycleSort;
    }

    return (a.applicationTypeId ?? 0) - (b.applicationTypeId ?? 0);
  });
};

// Adds a newly created application to the dashboard's list, replacing any entry for the same
// application so a repeated create (e.g. one that returned an existing application) can't list it twice.
export const addApplicationToPartnerApps = (
  partnerApps: ApplicationDataGridRowProps[],
  newApp: ApplicationDataGridRowProps
): ApplicationDataGridRowProps[] => {
  const otherApps = partnerApps.filter((app) => app.applicationId !== newApp.applicationId);

  return sortPartnerApps([newApp, ...otherApps]);
};

// Prepares a list reloaded from the server for the dashboard. Applications without a cycle can't be
// placed on the dashboard (or sorted), so they are dropped.
export const preparePartnerApps = (
  apps: ApplicationDataGridRowProps[]
): ApplicationDataGridRowProps[] => {
  return sortPartnerApps(apps.filter((app) => app.applicationCycle != null));
};
